import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import notice from 'src/common/components/Notice';
import { useStyles } from './styles';
import { usersAPI } from 'src/api/modules/users';
import { actions as changePassword } from '../../../redux/ducks/changePassword';
import { Button } from '@material-ui/core';

function ChangePassFn() {
	const dispatch = useDispatch();
	const classes = useStyles();
	const isDev = process.env.REACT_APP_ENVIRONMENT === 'DEV';
	const [loginForm, setLoginForm] = useState({
		usuario: localStorage.getItem('firstLogin'),
		pass: '',
		confirmPass: '',
	});
	
	const handleChange = (e) => {
		const { name, value } = e.target;
		setLoginForm({ ...loginForm, [name]: value });
	};

	const handleSubmit = (e) => {
		if (!loginForm.usuario || !loginForm.pass || !loginForm.confirmPass)
			return notice('Complete los datos', 'info');

		let typeUser = loginForm.usuario.substr(0, 2);

		if (typeUser !== 'IS')
			return notice(
				'El usuario no cumple con los requisitos para cambio de contraseña.'
			);

		let dataPost = {
			password: loginForm.pass,
			usuario: loginForm.usuario,
		};

		usersAPI
			.postChangePassword({ ...dataPost })
			.then((res) => {
				if (res.codigo === 'SAOC-400' || res.codigo === 'SAOC: 500')
					{
						notice(JSON.parse(JSON.stringify(res.mensaje)));
						dispatch(changePassword.SetChangePass(true));
						return false; 
					}
				else {
						notice('Cambio de Contraseña Exitosa', 'success');
						dispatch(changePassword.SetChangePass(false));
					 }
			})
			.catch((e) => {
				if (isDev) {
					if (e.response === undefined || e.response.data.mensaje === undefined) {
						notice('Ha ocurrido un error con su petición, contacte a un administrador.');
					} else{
						notice(JSON.parse(JSON.stringify(e.response.data.mensaje)));
							dispatch(changePassword.SetChangePass(true));
							return false; 
						}
				} else notice('Ha ocurrido un error con su petición, contacte a un administrador.');
			});
	};

	const onReturn = () => {
		if (loginForm.pass === loginForm.confirmPass) {
			handleSubmit();
		} else {
			notice('Las contraseñas no coinciden, favor de verificar');
			dispatch(changePassword.SetChangePass(true));
		}
	};

	const onCancel = () => {
		dispatch(changePassword.SetChangePass(false));
	};

	return (
		<div
			className={`login-form login-signin ${classes.containerForm}`}
			id="login_change_Password"
		>
			<div className="mb-10 mb-lg-10">
				<h3 className="font-size-h2 text-danger text-center">
					{/* <FormattedMessage id="AUTH.LOGIN.TITLE" data-testid="login-title" /> */}
				</h3>
			</div>
			{/* end::Head */}

			{/*begin::Form*/}
			<form>
				<div className={classes.containerForm}>
					<TextField
						id="userCP"
						name="usuario"
						className={classes.textField}
						variant="outlined"
						onChange={handleChange}
						disabled
						value={loginForm.usuario}
					/>
					<TextField
						id="passCP"
						name="pass"
						label="Nueva Contraseña"
						type="password"
						className={classes.textField}
						variant="outlined"
						onChange={handleChange}
					/>
					<TextField
						id="password"
						name="confirmPass"
						label="Confirmar Nueva Contraseña"
						type="password"
						className={classes.textField}
						variant="outlined"
						onChange={handleChange}
					/>
					<div className="text-center">
						<button
							className={`btn btn-light  font-weight-bold px-9 py-4 my-3 rounded-lg `}
							onClick={onCancel}
						>
							<span>Cancelar</span>
						</button>
						<Button
							className={`btn btn-danger font-weight-bold px-9 py-4 my-3 rounded-lg  ml-lg-10 `}
							onClick={onReturn}
							variant="text"
						>
							<p class="text-capitalize">Cambiar contraseña</p>
						</Button>
					</div>
				</div>
			</form>
			{/*end::Form*/}
		</div>
	);
}

export default ChangePassFn;
